import React from 'react';
import PauseAnyTimeSellingPoint from '../../desktop_personal_upgrade/helpers/pause_any_time_selling_point';
import SuccessGuaranteeSellingPointFrench from './success_guarantee_selling_point_french';
import ExpandableSellingPoint from './expandable_selling_point';
import {
  trackUpgradeFormSelectOption,
  trackViewSuccessGaurenteeExpandedText,
} from '../../tracking/event';
import './product_selector.scss';

const ProductSelector = ({
  currentProduct,
  context,
  updateCart,
  currencySymbol,
  customer,
  miscellaneous,
  products,
  localisations,
  experiments,
}) => {
  let hide_one_week_option = false;
  if (experiments && experiments.hide_one_week_option_experiment) {
    hide_one_week_option = experiments.hide_one_week_option_experiment;
  }
  const productRows = products.map((product) =>
    !hide_one_week_option || (hide_one_week_option && product.id != '1001') ? (
      <ProductRow
        key={product.id}
        product={product}
        selectedOption={currentProduct.id == product.id}
        context={context}
        updateCart={updateCart}
        currencySymbol={currencySymbol}
        customer={customer}
        miscellaneous={miscellaneous}
        localisations={localisations}
        experiments={experiments}
      />
    ) : null,
  );

  return (
    <form className="product-selector">
      <ul className="product-selector__rows">{productRows}</ul>
    </form>
  );
};

const ProductRow = (props) => {
  const rowClassName = `product-selector__row${
    props.selectedOption ? ' product-selector__row--selected' : ''
  }`;
  const originalPrice = props.product.original_price ? (
    <del aria-hidden="true" className="product-selector__original-price">
      <span className="price-currency">{props.currencySymbol}</span>
      <span className="price">{props.product.original_price}</span>
    </del>
  ) : (
    ''
  );
  const productSelected = () => {
    props.updateCart(props.product);
    trackUpgradeFormSelectOption({
      label: `${props.miscellaneous.context}|${props.customer.initial_type}|${props.product.price}|${props.product.duration}`,
    });
  };
  const hide_cost_per_day =
    props.customer.initial_type === 'seeker' &&
    props.context.context === 'my_account' &&
    props.product.id != '1006';

  const sellingPoints = () =>
    props.product.selling_points[props.context.product_type].map(
      (sellingPoint, index) => {
        sellingPoint =
          sellingPoint.includes('Pause your upgrade') &&
          props.context.context != 'global' ? (
            <PauseAnyTimeSellingPoint
              productType={props.context.product_type}
              sellingPoint={sellingPoint.split('upgrade')[1]}
            />
          ) : sellingPoint.includes('Garantie de réussite') ? (
            <SuccessGuaranteeSellingPointFrench sellingPoint={sellingPoint} />
          ) : sellingPoint.includes('Success guaranteed') ? (
            <ExpandableSellingPoint
              expandableText={'Success guaranteed'}
              subText={'(or get another 4 weeks free)'}
              expandedText={
                "If, for whatever reason you're not successful with your 4 week saver upgrade then, providing you haven't paused your original upgrade, we'll give you another 4 weeks free (&quot;Success Guarantee&quot;)! In order to claim, simply contact us within 3 days of your 4 week saver upgrade ending. Please note that the Success Guarantee can only be claimed once per 4 week upgrade purchased and can't be paused."
              }
              onClickCallback={trackViewSuccessGaurenteeExpandedText}
            />
          ) : (
            sellingPoint
          );
        return !hide_cost_per_day || (hide_cost_per_day && index != 0) ? (
          <li className="product-selector__selling-point" key={index}>
            <i className="far fa-check-circle product-selector__check" />{' '}
            <span>{sellingPoint}</span>
          </li>
        ) : null;
      },
    );

  return (
    <li className={rowClassName} id={props.product.id}>
      <label
        className="product-selector__label"
        htmlFor={`id${props.product.id}`}
      >
        <div className="product-selector__name">
          <input
            className="product-selector__option"
            onChange={() => productSelected()}
            checked={props.selectedOption}
            type="radio"
            name="product"
            id={`id${props.product.id}`}
          />
          {props.product.name}
        </div>
        <div className="product-selector__pricing">
          {originalPrice}
          <span className="product-selector__price">
            {props.currencySymbol + props.product.price}
          </span>
        </div>
        <ul className="product-selector__selling-points">{sellingPoints()}</ul>
        <p className="product-selector__promise">
          {props.localisations.not_a_subscription}
        </p>
      </label>
    </li>
  );
};

export default ProductSelector;
